export default __webpack_public_path__ + "static/media/directory-16px.08b873db.svg";